import React from 'react';
import { EmailValidationSuffixWUT } from '../email-validation/email-validation-suffix-wut';
import { EmailDeliverabilityStatus } from '../email-validation/email-validation-types';
import { useEmailDeliverabilityValidation } from '../email-validation/use-email-deliverability-validation';
import { TextInputFieldWUT } from './text-input-field-wut';
export const EmailInputFieldWUT = (props)=>{
    const { status: deliverabilityStatus, message, validate } = useEmailDeliverabilityValidation({
        fieldId: props.id,
        email: props.value,
        hasError: props.hasError
    });
    const suffix = deliverabilityStatus === EmailDeliverabilityStatus.CHECKING || deliverabilityStatus === EmailDeliverabilityStatus.INVALID ? /*#__PURE__*/ React.createElement(EmailValidationSuffixWUT, {
        status: deliverabilityStatus,
        message: message
    }) : undefined;
    const handleBlur = ()=>{
        validate();
        props.onBlur?.();
    };
    return /*#__PURE__*/ React.createElement(TextInputFieldWUT, {
        ...props,
        type: "email",
        suffix: suffix,
        onBlur: handleBlur
    });
};

//# sourceMappingURL=email-input-field-wut.js.map